import styled from '@emotion/styled';
import {IconChevronRight} from '@travel-frontend/icons';

export const Indicator = styled(IconChevronRight)`
  color: ${({theme}) => theme.colors.interactionSecondary};
`;
